import React, { useState } from 'react';
import { Dropdown, Button } from 'react-bootstrap';
import axios from "axios";
// import download from 'downloadjs';
//import { AiOutlineDownload } from 'react-icons/ai';
import { BsFiletypeDocx, BsFiletypePdf } from 'react-icons/bs';

const Preparazione_documenti = (props) => {

    const [value, setValue] = useState();


    function invia_mail_di_inizio_stage() {
        console.log('invia_mail_di_inizio_stage');

    }


    const handleSubmit1 = (e) => {
        alert('scrivi qualcosa')

    }

    function preparazione_documenti(documento, tipo) {
        console.log('Prepara documenti');
        const nuovo_progetto = {
            id: props.progetto._id,
            id_alunno: props.progetto.id_alunno,
            id_ditta: props.progetto.id_ditta,
            
            tutor: props.tutor,
            data_inizio: props.progetto.data_inizio,
            data_fine: props.progetto.data_fine,
            documento: documento
        }
        console.log(documento);
        axios.post('/transfer_s3/preparazione_documenti_progetto', nuovo_progetto)
        .then((res) => {
            console.log(res.data)
            if (tipo === "doc") {download_docx(documento)}
            if (tipo === "pdf") {download_pdf (documento) }
            
              
//                SET_variab_aggiorna(JSON.stringify(res.data))
        }).catch((error) => {
            console.log(error)
        });
    }


    const download_docx = (documento) => {
        const cognome = props.progetto.id_alunno.cognome
        const nome = props.progetto.id_alunno.nome
        let indirizzo
        if (documento === 'progetto') {
            indirizzo = 'Progetto_docx'
        }
        if (documento === 'rapporto') {
            indirizzo = 'Rapporto_docx'
        }
        if (documento === 'patto') {
            indirizzo = 'Patto_docx'
        }
        console.log('indirizzo ' + indirizzo)
        
        axios.get('/transfer_s3/progetto_docx_ottieni_url/' + indirizzo + '/' + cognome + '/' + nome )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')

                if (newWindow) newWindow.opener = null
               
//                return res.data
            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };


    function download_pdf (documento) {
        const cognome = props.progetto.id_alunno.cognome
        const nome = props.progetto.id_alunno.nome
        let indirizzo = ''
        if (documento === "patto") {indirizzo = 'Patto_pdf'}
        if (documento === "progetto") {indirizzo = 'Progetto_pdf'}
        if (documento === "rapporto") {indirizzo = 'Rapporto_pdf'}
        

        console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')

        axios.get('/transfer_s3/progetto_pdf_ottieni_url/' + indirizzo + '/' + cognome + '/' + nome )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx PDF url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')
//                if (newWindow) newWindow.opener = null
            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };



   


    return (
        <div >
          
            <div class="dropdown-divider"></div>
            { /* 
            <Dropdown.Item onClick={() => preparazione_documenti('progetto')}>Prepara_documenti</Dropdown.Item>
            <Dropdown.Item onClick={download_pdf}>Download Progetto.pdf</Dropdown.Item>
            */}
         
      
             <div className='container d-flex justify-content-between'>
                <div classname="container: {justifyContent: 'center', alignItems: 'center', flex:1}">
                    Patto formativo   

                </div>
                <div className='d-flex flex-row-reverse'>
            
                    <Button onClick={() => preparazione_documenti('patto', 'pdf')} variant="light">
                        <BsFiletypePdf />
                    </Button>
                    <Button onClick={() => preparazione_documenti('patto', 'doc')} variant="light">
                            <BsFiletypeDocx/>     
                    </Button>
                 
                </div>
            </div>
            <Dropdown.Item onClick={() => preparazione_documenti('rapporto', 'doc')}>Rapporto visita</Dropdown.Item>
            
        </div>
    )
}
export default Preparazione_documenti;